import { subMinutes } from 'date-fns/subMinutes';

export const DEFAULT_DEDUCT_MINUTE = 30;

export const deductMinutesFromCurrentTime = (min: number) => subMinutes(new Date(), min);
